module.exports = __webpack_public_path__ + "img/salad-wine-1600x800.a520bfee.jpg";